/*
 *
 * General constants
 *
 */

enum ActionTypes {
  SET_CUSTOM_MODE = 'app/CONFIGURATOR/GENERAL/SET_CUSTOM_MODE',
  SET_CONTEXT = 'app/CONFIGURATOR/GENERAL/SET_CONTEXT',
  DISPLAY_PIECES_LIST = 'app/CONFIGURATOR/GENERAL/DISPLAY_PIECES_LIST',
  DISPLAY_VIEWER = 'app/CONFIGURATOR/GENERAL/DISPLAY_VIEWER',
  SET_COLORS_PANEL = 'app/CONFIGURATOR/GENERAL/SET_COLORS_PANEL',
  SET_SHELVES_MODE = 'app/CONFIGURATOR/GENERAL/SET_SHELVES_MODE',
  OPEN_DOORS_MODE = 'app/CONFIGURATOR/GENERAL/OPEN_DOORS',
  SWITCH_LANGUAGE = 'app/CONFIGURATOR/GENERAL/SWITCH_LANGUAGE',
  DISPLAY_DIMENSION = 'app/CONFIGURATOR/GENERAL/DISPLAY_DIMENSION',
}

export enum ActivePanel {
  drawers = 'drawers',
  panes = 'panes',
  plates = 'plates',
  handles = 'handles',
  IntermediateShelf = 'IntermediateShelf',
  crossPieces = 'crossPieces',
  paint = 'paint',
  upperShelf = 'UpperShelf',
}

export default ActionTypes;
